import { useState } from "react";
import { toast } from "sonner";
import { Download } from "lucide-react";
import { http, formatApiError } from "../lib/api";

export const todayISO = () => new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Paris" });
export const frDate = (d) => (d ? d.split("-").reverse().join("/") : "");
export const periodLabel = (s, e) => (!s && !e ? "Toutes dates" : s === e ? `Le ${frDate(s)}` : `Du ${frDate(s)} au ${frDate(e)}`);

export const ExportPdfButton = ({ title, subtitle, columns, rows, filename, testid = "export-pdf-btn", landscape = true }) => {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const r = await http.post("/export/table.pdf", { title, subtitle, columns, rows: rows().map((x) => x.map((v) => String(v ?? ""))), landscape }, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
      Object.assign(document.createElement("a"), { href: url, download: `${String(title || filename).replace(/[\\/:*?"<>|]+/g, " ").replace(/\s*—\s*/g, " - ").replace(/\s+/g, " ").trim()} - ${new Date().toISOString().slice(0, 10).replace(/-/g, "")}.pdf` }).click();
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <button data-testid={testid} onClick={go} disabled={busy} className="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-semibold text-white rounded-md disabled:opacity-60 whitespace-nowrap shrink-0" style={{ backgroundColor: "var(--brand-primary)" }}>
      <Download className="h-4 w-4" /> {busy ? "Export…" : "Exporter PDF"}
    </button>
  );
};

export const monthRange = () => { const n = new Date(todayISO()); const p = (x) => String(x).padStart(2, "0");
  return [`${n.getFullYear()}-${p(n.getMonth() + 1)}-01`, `${n.getFullYear()}-${p(n.getMonth() + 1)}-${p(new Date(n.getFullYear(), n.getMonth() + 1, 0).getDate())}`]; };

export const MonthButton = ({ start, end, onClick, testid }) => {
  const [a, b] = monthRange();
  return <TodayButton testid={testid} active={start === a && end === b} onClick={() => onClick(a, b)} label="Mois en cours" />;
};

export const TodayButton = ({ onClick, active, testid = "today-btn", label = "Aujourd'hui" }) => (
  <button data-testid={testid} onClick={onClick} className={`text-xs font-semibold px-3 py-1.5 rounded border ${active ? "text-white" : "bg-white text-slate-600 border-slate-300 hover:bg-slate-50"}`}
    style={active ? { backgroundColor: "var(--brand-primary)", borderColor: "var(--brand-primary)" } : {}}>{label}</button>
);
